// Stylesheets
import './assets/scss/site.scss';

import { hover } from './assets/modules/hover';
import { scrollNav } from './assets/modules/scrollNav';
import { audioPlayer } from './assets/modules/audioPlayer';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';

const init = () => {
  hover();
  scrollNav();
  audioPlayer();
  initPhotoSwipeFromDOM('.js-pswp-container');
}

init();